export const topSafeHeight = () => 0;
